import { IOrderPagedRequest, OrderStatisticsResponse } from "src/_pages/admin/interfaces/oms-interface";
import { api } from "../_api/api";
import { IApiResult, IPagedRequest } from "../_interfaces";
import { OMS_API_URL } from "../_enums/api-url.enum";

export default class OmsService {
  public static createOrder(param: any) {
    return api.post("/order/create-order", param);
  }
  public static getPendingOrders() {
    return api.get("/order/pending-orders");
  }
  public static getOrdersPaging(param: IOrderPagedRequest) {
    return api.post("/order/orders-paging", param);
  }
  public static getUserOrdersPaging(param: IOrderPagedRequest) {
    return api.post("/order/user-orders-paging", param);
  }

  public static getOrderStatistic(params: any) {
    return api.post<OrderStatisticsResponse>(`/order/statistic`, params);
  }

  public static deleteOrder(id: string) {
    return api.delete(`${OMS_API_URL.DELETE_ORDER}/${id}`) as unknown as Promise<IApiResult | undefined>;
  }
}
